import styles from './ReturnLink.module.css';

interface ReturnLinkProps {
  hidden?: boolean;
}

export function ReturnLink({ hidden = false }: ReturnLinkProps) {
  return (
    <a
      href="https://hypneuronerd.ing/"
      className={`${styles.link} ${hidden ? styles.linkHidden : ''}`}
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
    >
      ← return to the gallery
    </a>
  );
}
